// removed by extract-text-webpack-plugin
module.exports = {"dragHandle":"_2-8rYsOZ7A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PagesTable/PagesTable.scss
// module id = 900
// module chunks = 0